import { Components } from '@mui/material'

export function OverridedTabs(): Components {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          '&:not(.Mui-selected)': {
            opacity: 0.7,
          },
          'textTransform': 'uppercase',
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        scrollButtons: 'auto',
        selectionFollowsFocus: true,
        variant: 'scrollable',
      },
      styleOverrides: {
        root: {
          backgroundColor: '#fbfbfb',
        },
        scrollButtons: {
          '&.Mui-disabled': {
            display: 'none !important',
          },
        },
      },
    },
  }
}
